var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBuilding(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 53",
    style: {
      fill: "none",
      opacity: 0.509
    },
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 49",
    d: "M407.022 1545.9h-10.967v-17.957h10.967zm-9.967-1h8.967v-15.957h-8.967z",
    transform: "translate(-395 -1526.91)",
    style: {
      fill: "#939393"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 50",
    d: "M404.036 1542.005h-7.98v-14.058h7.98zm-6.98-1h5.98v-12.058h-5.98z",
    transform: "translate(-385 -1523.011)",
    style: {
      fill: "#939393"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 42 - Outline",
    d: "M0 0h2v2H0z",
    transform: "translate(4 4)",
    style: {
      fill: "#939393"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 43 - Outline",
    d: "M0 0h2v2H0z",
    transform: "translate(7 4)",
    style: {
      fill: "#939393"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 44 - Outline",
    d: "M0 0h2v2H0z",
    transform: "translate(4 7)",
    style: {
      fill: "#939393"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 45 - Outline",
    d: "M0 0h2v2H0z",
    transform: "translate(7 7)",
    style: {
      fill: "#939393"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 46 - Outline",
    d: "M0 0h2v2H0z",
    transform: "translate(4 10)",
    style: {
      fill: "#939393"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 47 - Outline",
    d: "M0 0h2v2H0z",
    transform: "translate(7 10)",
    style: {
      fill: "#939393"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 48 - Outline",
    d: "M0 0h2v3H0z",
    transform: "translate(14 8)",
    style: {
      fill: "#939393"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 49 - Outline",
    d: "M0 0h2v2H0z",
    transform: "translate(14 12)",
    style: {
      fill: "#939393"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 51",
    d: "M402.892 1544.89h-1v-3.948h-.984v3.948h-1v-4.948h2.984z",
    transform: "translate(-394.912 -1526.916)",
    style: {
      fill: "#939393"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.df4a9885e57df6da10cf5a4cefb90867.svg";
export { ForwardRef as ReactComponent };